import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import TicketsTable from "./ticketsTable";
import Pagination from "../../components/common/pagination";
import { getTickets, deleteTicket } from "../../services/ticketService";
import SearchBox from "../../components/searchBox";
import LoadingIndicator from "../../components/common/LoadingIndicator";

class Tickets extends Component {
  state = {
    tickets: [],
    currentPage: 1,
    pageSize: 10,
    searchQuery: "",
    sortColumn: { path: "id", order: "desc" },
    customerList: [],
    serviceList: [],
    customerAccountList: [],
    category: [
      { id: 1, label: "Sales", value: 1 },
      { id: 2, label: "Support", value: 2 },
      { id: 3, label: "Enquiry", value: 3 },
      { id: 4, label: "Suggestion", value: 4 }
    ],
    priorityList: [
      { id: 1, label: "Critical", value: 1 },
      { id: 2, label: "High", value: 2 },
      { id: 3, label: "Medium", value: 3 },
      { id: 4, label: "Low", value: 4 }
    ],
    statusList: [
      { id: 1, label: "New", value: 1 },
      { id: 2, label: "Assigned", value: 2 },
      { id: 3, label: "In Progress", value: 3 },
      { id: 4, label: "Pending", value: 4 },
      { id: 5, label: "Resolved", value: 5 },
      { id: 6, label: "Closed", value: 6 }
    ],
    totalCount: 0,
    loading: true,
  };

  formatDate (date) {
    const formatted = moment(date).format("Do MMM. YYYY").toString();
    return formatted;
  }

  async componentDidMount() {
    await this.populateTickets();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.state?.refreshToken !== this.props.location?.state?.refreshToken) {
      this.setState({
        currentPage: 1,
        searchQuery: "",
        sortColumn: { path: "id", order: "desc" }
      }, () => {
        this.populateTickets();
      });
    }
  }

  handleDelete = async ticket => {
    const originalTickets = this.state.tickets;
    const tickets = originalTickets.filter(a => a.username !== ticket.username);
    this.setState({ tickets });

    try {
      await deleteTicket(ticket.username);
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error("This ticket has already been deleted.");

      this.setState({ ticket: originalTickets });
    }
  };

  handleLike = ticket => {
    const tickets = [...this.state.tickets];
    const index = tickets.indexOf(ticket);
    tickets[index] = { ...tickets[index] };
    tickets[index].liked = !tickets[index].liked;
    this.setState({ tickets });
  };

  handlePageChange = page => {
    this.setState({ currentPage: page }, () => {
      this.populateTickets();
    });
  };

  handleSearch = query => {
    this.setState({ searchQuery: query, currentPage: 1 }, () => {
      this.populateTickets();
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn }, () => {
      this.populateTickets();
    });
  };

  async populateTickets() {
    try {
      const { currentPage, pageSize, searchQuery, sortColumn } = this.state;

      const params = {
        page: currentPage,
        pageSize,
        sortBy: sortColumn.path,
        sortOrder: sortColumn.order,
      };

      if (searchQuery) params.search = searchQuery;

      const response = await getTickets(params);
      const tickets = response?.data?.data || [];
      const totalCount = response?.data?.pagination?.totalCount || 0;

      const Tickets = tickets.map(ticket => ({
        ...ticket,
        createdAt: ticket?.createdAt ? this.formatDate(ticket.createdAt) : '',
        status: this.state.statusList.find(s => s.id === parseInt(ticket.status))?.label,
        priority: this.state.priorityList.find(p => p.id === parseInt(ticket.priority))?.label,
      }));

      this.setState({
        tickets: Tickets,
        totalCount,
        loading: false,
      });
    } catch (error) {
      console.error('Error loading tickets:', error);
      toast.error('Error loading tickets');
      this.setState({ loading: false });
    }
  }

  render() {
    const { pageSize, currentPage, sortColumn, searchQuery, tickets, totalCount } = this.state;
    const { user } = this.props;

    return (        
    <React.Fragment>
      <div className="row">
        <div className="col">
          <div>
            <div className="pull-right">
              {user && (
                <Link
                  to="/tickets/new"
                  className="btn btn-primary btn-sm"
                  style={{ marginBottom: 20 }}
                >
                  <i className="fa fa-plus-circle" /> New Ticket
                </Link>
              )}
            </div>
            <div>
              {this.state.loading && <LoadingIndicator message="Loading tickets..." />}
              {!this.state.loading &&
              <div>
                <p>You have {totalCount ? totalCount : "no"} support ticket{(totalCount>1 || totalCount===0) && "s"}.</p>
              </div>}
            </div>
          </div>
          <SearchBox value={searchQuery} onChange={this.handleSearch} />
          <TicketsTable
            tickets={tickets}
            sortColumn={sortColumn}
            searchQuery={searchQuery}
            onLike={this.handleLike}
            onDelete={this.handleDelete}
            onSort={this.handleSort}
          />
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={this.handlePageChange}
          />
        </div>
      </div>
    </React.Fragment>
    );
  }
}

export default Tickets;